import { cloneElement, createElement } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import styles from './Tab.module.scss';

const Tab = ({
  className,
  selectedClassName,
  href,
  label,
  value,
  onClick,
  icon,
  ...props
}) => {
  const handleClick = (evt) => {
    if (props?.onChange) {
      props.onChange(evt, value);
    }

    if (onClick) {
      onClick(evt);
    }
  };

  return createElement(
    href ? Link : 'button',
    {
      className: cn(styles.root, className, {
        [selectedClassName]: props?.selected,
      }),
      to: href,
      onClick: handleClick,
      ...props,
    },

    label,
    icon &&
      cloneElement(icon, {
        selected: props?.selected,
      })
  );
};

export default Tab;
